import zxcvbn from "zxcvbn";

enum PasswordStrengthState {
  Empty,
  Short,
  Valid,
}

const meta = {
  [PasswordStrengthState.Empty]: {
    color: "bg-gray-400",
    text: "Password strength",
  },
  [PasswordStrengthState.Short]: { color: "bg-gray-400", text: "Too short" },
  [PasswordStrengthState.Valid]: [
    { color: "bg-red-400", text: "Very Weak" },
    { color: "bg-red-400", text: "Weak" },
    { color: "bg-yellow-400", text: "Good" },
    { color: "bg-green-400", text: "Strong" },
    { color: "bg-green-400", text: "Very Strong" },
  ],
} as const;

function getText(state: PasswordStrengthState, score: number) {
  if (state === PasswordStrengthState.Valid) {
    return meta[state][score].text;
  }
  return meta[state].text;
}

function getColor(state: PasswordStrengthState, score: number, index: number) {
  if (state === PasswordStrengthState.Valid) {
    return score < index ? "bg-gray-400" : meta[state][score].color;
  }
  return meta[state].color;
}

export function PasswordStrength({ password }: { password: string | null }) {
  const state = !password
    ? PasswordStrengthState.Empty
    : password.length < 8
      ? PasswordStrengthState.Short
      : PasswordStrengthState.Valid;
  const { score } = zxcvbn(password ?? "");
  return (
    <div>
      <div className="my-2 flex h-1 items-stretch gap-1">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className={`flex-auto rounded-full ${getColor(state, score, index)}`}
          ></div>
        ))}
      </div>
      <div className="text-xs leading-none text-gray-400">
        {getText(state, score)}
      </div>
    </div>
  );
}
